import {BuildingNodeType, WorkspaceReservation} from '@lib/store';

export const getNodeTypeAndId = (
  buildingId: string,
  floorId?: string,
  areaId?: string,
  deskIds?: string[],
): {nodeType: BuildingNodeType; nodeIds: string[]} => {
  if (deskIds?.length) {
    return {nodeType: 'Desk', nodeIds: deskIds};
  }
  if (areaId) {
    return {nodeType: 'Area', nodeIds: [areaId]};
  }
  if (floorId) {
    return {nodeType: 'Floor', nodeIds: [floorId]};
  }
  return {nodeType: 'Building', nodeIds: [buildingId]};
};

export const getSpaceNodeTypeAndId = (
  buildingId: string,
  floorId: string,
  areaId: string,
): {spaceNodeType: BuildingNodeType; spaceNodeId: string} => {
  if (areaId) {
    return {spaceNodeType: 'Area', spaceNodeId: areaId};
  }
  if (floorId) {
    return {spaceNodeType: 'Floor', spaceNodeId: floorId};
  }
  return {spaceNodeType: 'Building', spaceNodeId: buildingId};
};

export const getWorkspaceReservationNodeType = (workspaceReservation?: WorkspaceReservation): BuildingNodeType => {
  if (!workspaceReservation?.currentMember?.location) {
    return 'Building';
  }
  const {buildingId, floorId, areaId, deskId} = workspaceReservation.currentMember.location;
  return getNodeTypeAndId(buildingId, floorId, areaId, deskId ? [deskId] : undefined).nodeType;
};

export const getDeskIdsOfWorkspaceReservation = (workspaceReservation?: WorkspaceReservation): string[] => {
  if (!workspaceReservation) {
    return [];
  }
  return workspaceReservation.members.reduce((acc, {location, status}) => {
    const deskId = location.deskId;
    if ((status === 'Confirmed' || status === 'InvitationPending') && deskId) {
      return [...acc, deskId];
    }
    return acc;
  }, [] as string[]);
};
